// 土耳其
export default
{ 
 common: { 
    notshow: 'Bugün gösterme',
 unit: 'USDT', 
 day: 'Gün', 
 week: 'Hafta', 
 save: 'Kaydet', 
 submit: 'Gönder', 
 confirmtitle: 'İşlemi uygulamayı onayla', 
 confirm: 'Onayla', 
 reset: 'Sıfırla', 
 refresh: 'Yenile', 
 copy: 'Kopyala', 
 copysuccessful: 'Kopyalama başarılı', 
 modify: 'Değiştir', 
 binding: 'Bağlama', 
 finished: 'Tamamlandı', 
 canceled: 'İptal edildi', 
 cancel: 'İptal', 
 all: 'Tümü', 
 back: 'Geri', 
 loading: 'Yükleniyor...', 
 nomore: 'Tüm kayıtlar', 
 errortxt: 'Yükleme başarısız', 
 loosing: 'Serbest bırakmak için yenile...', 
 pulling: 'Aşağı çekerek yenile...', 
 nodata: 'Şu anda kayıt yok', 
 buy: 'Al', 
 buyup: 'Artışa yatırım yap', 
 buydown: 'Düşüşe yatırım yap', 
 sell: 'Sat', 
 forserver: 'Lütfen müşteri hizmetlerine danışın', 
 total: 'Toplam', 
 status1: 'Onay bekliyor ', 
 status2: 'Tamamlandı ', 
 status3: 'Reddedildi', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'Havale', 
 }, 
 footer: { 
 home: 'Ana Sayfa', 
 market: 'Piyasa', 
 exchange: 'Kripto Para', 
 options: 'Opsiyonlar', 
 assets:'Varlıklar', 
 change: 'Transfer', 
 recharge: 'Para Yatırma', 
 withdrawal: 'Para Çekme' 
 }, 
 home: { 
 menu1:'Opsiyon Ticareti', 
 menu1desc: 'BTC/USDT vb. destekliyor', 
 menu2: 'Hızlı Para Yatırma', 
 menu3: 'Para Çekme', 
 menu4: 'Müşteri Hizmetleri', 
 menu5: 'Anında Değişim', 
 menu6: 'Kredi Destek', 
 menu7: 'Staking Madenciliği', 
 menu8: 'Staking', 
 menu9: 'Hesap Transferi', 
 ranktitle: 'Artış Sıralaması', 
 name: 'Ad', 
 price: 'Son Fiyat', 
 risefall: 'Artış/Düşüş', 
 }, 
 register: { 
 register: 'Kayıt Ol', 
 login: 'Giriş Yap', 
 email: 'E-posta', 
 phone: 'Telefon', 
 accountplaceholder: 'Lütfen hesabınızı girin', 
 emailplaceholder: 'Lütfen e-postanızı girin', 
 phoneplaceholder: 'Lütfen telefonunuzu girin', 
 pwdplaceholder:'Lütfen şifrenizi girin', 
 pwdplaceholder1:'Şifre 6-20 haneli harf ve rakamdan oluşmalıdır', 
 agepwdplaceholder: 'Lütfen şifrenizi tekrar girin', 
 agepwdplaceholder1: 'Şifreler eşleşmiyor', 
 invitecodeplaceholder: 'Lütfen davet kodunuzu girin', 
 remember: 'Şifremi hatırla', 
 fotget: 'Şifremi unuttum' 
 }, 
 market:{ 
 title: 'Piyasa', 
 all: 'Tümü' 
 }, 
 member:{ 
 reputation:'Onur Puanı', 
 identity_authentication:'Kimlik Doğrulama', 
 under_review:'Gözden geçiriliyor', 
 certified:'Doğrulanmış', 
 awaiting_certification:'Doğrulama Bekliyor', 
 binding_withdrawal_address: 'Çekme Adresini Bağla', 
 currently_selected_currency:'Şu anda seçili para birimi', 
 withdrawal_address:'Çekme Adresi', 
 sharing_link:'Paylaşım Linkim', 
 my_promotion_code:'Tanıtım Kodum', 
 promotion_code:'Tanıtım Kodu', 
 system_message:'Sistem Mesajı', 
 night_mode:'Gece Modu', 
 security_center:'Güvenlik Merkezi', 
 seted: 'Ayarlandı', 
 noset: 'Ayarlanmadı', 
 login_password:'Giriş Şifresi', 
 transaction_password:'Para Çekme Şifresi', 
 app_download:'Uygulama İndir', 
 log_out:'Çıkış Yap' ,
        aboutus: 'Web Sitesi Tanıtımı'
 }, 
 identity:{ 
 title: 'Kimlik Doğrulama', 
 name: 'Ad', 
 nameplaceholder: 'Lütfen gerçek adınızı girin', 
 uploader: 'Kimlik Fotoğrafını Yükle', 
 tip1: 'Kimlik ön yüzünü yükle', 
 tip2: 'Kimlik arka yüzünü yükle' 
 }, 
 address: { 
 title: 'Çekme Adresini Bağla', 
 bType: 'Şu anda seçili para birimi', 
 address: 'Çekme Adresi', 
 addressplaceholder:'Lütfen çekme adresinizi girin', 
 }, 
 security:{ 
 title: 'Güvenlik Merkezi', 
 modifypwd: 'Giriş Şifresi', 
 resetlegalpwd: 'Para Çekme Şifresi', 
 loginpwd: 'Yeni Giriş Şifresi', 
 pwdage: 'Şifreyi Tekrar Girin', 
 loginpwdplaceholder:'Lütfen mevcut giriş şifrenizi girin', 
 loginnewpwdplaceholder: 'Lütfen yeni giriş şifrenizi girin', 
 moneypwd: 'Lütfen para çekme şifrenizi girin', 
 pwdageplaceholder:'Lütfen şifrenizi tekrar girin' 
 }, 
 trade:{ 
 title: 'Kripto Para Ticareti', 
 price: 'Fiyat', 
 num: 'Adet', 
 entrust: 'Mevcut Sipariş', 
 clinch: 'Gerçekleşen İşlem', 
 used: 'Kullanılabilir', 
 buyed: 'Satın Alınabilir', 
 amount: 'Ticaret Miktarı', 
 limitprice: 'Limit Fiyat', 
 marketprice: 'Piyasa Fiyat', 
 forprice: 'En İyi Fiyata İşlem Yap', 
 errorMoney: 'Kullanılabilir bakiye yetersiz', 
 priceerror: 'Lütfen sipariş fiyatını girin', 
 numerror: 'Lütfen sipariş adetini girin', 
 moneyerror: 'Lütfen sipariş tutarını girin', 
 }, 
 assets:{ 
 allconvert:'Toplam Varlık Dönüştürülmüş', 
 usenum: 'Kullanılabilir', 
 freeze: 'Dondurulmuş', 
 convert: 'Dönüştürülmüş', 
 tab1:'Varlıklar', 
 tab11: 'Toplam Varlık Dönüştürülmüş', 
 tab12: 'Opsiyon Dönüştürülmüş', 
 tab13: 'Fond Dönüştürülmüş', 
 tab14: 'Kuantitatif Dönüştürülmüş', 
 tab2:'Opsiyonlar', 
 tab21: 'Opsiyon Hesabı', 
 tab3:'Fondlar', 
 tab31:'Fond Hesabı', 
 tab4:'Kuantitatif', 
 tab41:'Kuantitatif Hesabı', 
 tbhead1: 'Mali Kayıtlar', 
 tbhead2: 'Çekme Kayıtları', 
 tbhead3: 'Yatırma Kayıtları', 
 tbhead4: 'Transfer Kayıtları', 
 rcdnum: 'Adet', 
 rcd: 'Kayıt', 
 rcdtime: 'Zaman' , 
 rcdstatus: 'Durum', 
 rcddesc: 'Açıklama', 
 rcdaddress: 'Yatırma Adresi' 
 }, 
 change:{ 
 title: 'Transfer', 
 from: 'Kaynak {name}', 
 to: 'Hedef {name}', 
 frmtitle: 'Transfer Miktarı', 
 inputplaceholder: 'Lütfen transfer miktarını girin', 
 btntxt:'Transfer' 
 }, 
 recharge:{ 
 title: 'Para Yatırma', 
 bType: 'Şu anda seçili para birimi', 
 address: 'Yatırma Adresi', 
 token: 'Ödeme Belgesi', 
 tokenplaceholder: 'Lütfen ödeme belgesini yükleyin', 
 num: 'Yatırma Miktarı', 
 numplaceholder: 'Lütfen miktarı girin', 
 btn: 'Onay İçin Gönder', 
 bankname: 'Banka Adı', 
 bankno: 'Banka Hesap No', 
 accountname: 'Alıcı Hesap Adı', 
 bankaddress: 'Banka Adresi', 
 bankcode: 'Banka Havale Kodu', 
 companyaddress: 'Şirket Adresi' 
 }, 
 withdrawal:{ 
 title:'Para Çekme', 
 frmtitle1: 'Miktar', 
 frmplaceholder1: 'Çekme miktarı {min} - {max} arasında olmalıdır', 
 frmtitle2: 'Para Çekme Şifresi', 
 frmplaceholder2: 'Lütfen para çekme şifrenizi girin', 
 getnum: 'Alınan Miktar', 
 fee:'Ücret', 
 btn: 'Para Çek' 
 }, 
 exchangeb:{ 
 title: 'Değişim', 
 account: 'Hesap', 
 btn: 'Değiştir', 
 numerror: 'Lütfen değişim miktarını girin' 
 }, 
 option:{ 
 title: 'Opsiyonlar', 
 typetitle: 'Saniye Sözleşmesi', 
 listtitle: 'Pozisyonlar', 
 kline: 'K Çizgisi', 
 high: 'Yüksek', 
 low: 'Düşük', 
 nums: '24 Saatlik Ciro', 
 time: 'Zaman', 
 transaction: 'Ticaret Modu', 
 quantity: 'Açılış Miktarı', 
 quantityerror: 'Lütfen açılış miktarını girin', 
 times: 'Açılış Zamanı', 
 times1: 'Yerleşim Zamanı',
 account: 'Hesap Bakiyesi', 
 buyup:'Artışa yatırım yap', 
 buydown: 'Düşüşe yatırım yap', 
 tab1: 'Pozisyon Listesi', 
 tab2: 'Sipariş Kayıtları', 
 num: 'Adet', 
 price1: 'Satın Alma Fiyatı', 
 price2: 'Doldurma Fiyatı', 
 profitandloss: 'Tahmini Kâr/Zarar', 
 profitandloss1: 'Kâr/Zarar', 
 countdown: 'Sayıma Kaldı', 
 waitfinish: 'Hesaplanmıyor', 
 finishing: 'Hesaplanıyor...', 
 finished: 'Hesaplandı', 
 order_price: 'Güncel Fiyat', 
 order_cycle: 'Dönem', 
 order_type: 'Tip', 
 order_money: 'Tutar', 
 order_time: 'Pozisyon Açma', 
 order_get: 'Kâr', 
 order_btn: 'Sipariş Vermeye Devam' 
 },
    "tradelst": {
        "title": "Siparişlerim",
        "tab1": "Siparişler",
        "tab2": "Tamamlanan Ticaretler",
        "tab3": "İptal Edilenler",
        "usdtnum": ""
    },
    "loans": {
        repayment: 'Geri ödeme',
        "title": "Kredi Destek",
        "order_tab": "Kredi Siparişleri",
        "pro_tab": "Kredi Ürünleri",
        "Institution": "Kredi Veren Kurum",
        "Amount": "Tutar",
        "DailyInterest": "Günlük Faiz",
        "RepaymentPeriod": "Ödeme Dönemi",
        "Application": "Kredi Başvuru",
        "orderno": "Sipariş No",
        "AllInterest": "Toplam Faiz",
        "RepaymentDate": "Ödeme Tarihi",
        "RepaymentMethod": "Ödeme Yöntemi",
        "Onetime": "Tek Seferlik",
        "Expected_loan_amount": "Beklenen Borç Tutarı",
        "Expected_loan_amounterror": "Borç tutarı {min} - {max} arasında olmalıdır",
        "imgplaceholdr": "Kredi Verme (Lütfen resmin net görünür olduğundan emin olun)",
        "icon1": "Kimlik Belgesinin Ön Yüzünü Yükle",
        "icon2": "Kimlik Belgesinin Arka Yüzünü Yükle",
        "icon3": "Elindeki Kimlik Belgesini Yükle",
        "status1": "Onay Bekliyor",
        "status2": "Onaylandı",
        "status3": "Onay Reddedildi"
    },
    "lockming": {
        "title": "Staking Madenciliği",
        "order_tab": "Madenci Siparişleri",
        "pro_tab": "Madenci Pazarı",
        "locknum": "En Küçük Kilitleme Miktarı",
        "getforday": "Getiri/Gün",
        "days": "Gün",
        "estimation": "Tahmini Getiri",
        "real": "Gerçekten Kazanılmış",
        "balance": "Cüzdan Bakiyesi",
        "nums": "Kilitleme Miktarı",
        "tolockming": "Kilitle",
        "stime": "Başlangıç Tarihi",
        "etime": "Bitiş Tarihi"
    },
    "transfer": {
        "title": "Hesap Transferi",
        "searchtxt": "Lütfen alıcı hesabını girin",
        "ReceivingAccount": "Alıcı Hesap Bilgisi",
        "toaccount": "Hesap",
        "confirmtxt": "Lütfen alıcı hesabını onaylayın",
        "confirmedtxt": "Alıcı hesabı onaylandı",
        "numtxt": "Transfer Miktarı",
        "numerror": "Lütfen transfer miktarını girin",
        "fee": "İç Transfer Ücretsiz",
        "ArrivalTime": "Geliş Zamanı",
        "Immediately": "Hemen Gelir",
        "realnum": "Gerçekten Gelen Miktar",
        "btn": "Transferi Onayla",
        "transfering": "Transfer Ediliyor",
        "orderNo": "Sipariş No",
        "stime": "Transfer Zamanı",
        "etime": "Geliş Zamanı",
        "receiving": "Alıcı Hesap",
        "type": "Para Birimi",
        "num": "Transfer Edilen Miktar",
        "arrivalnum": "Gelen Miktar"
    },
    "staking": {
        "title": "Staking",
        "record": "Kayıtlar",
        "getforyear": "Referans Yıllık Getiri",
        "time": "Yatırım Süresi",
        "snum": "En Küçük Yatırım Miktarı",
        "snumerror": "Lütfen yatırım miktarını girin",
        "snumerror1": "Yatırım miktarı {num} dan düşük olamaz",
        "join": "Hemen Katıl",
        "opentime": "Pozisyon Açma Zamanı",
        "money": "Yatırım Tutarı",
        "days": "Dönem",
        "recordget": "Yıllık Getiri",
        "gets": "Getiri",
        "stime": "Başlangıç Tarihi",
        "etiem": "Bitiş Tarihi",
        "redeemStaking": "Geri Çek",
        "status0": "Staking Yapılıyor",
        "status1": "Sipariş Bitti",
        "status2": "Sipariş Geri Çekildi"
    },
    bank:{
        title: 'Banka Kartı Bağlama',  // BDDK Ödeme Hizmetleri Yönetmeliği Madde 6
        bankName: 'Banka Adı',  // TBB (Türkiye Bankalar Birliği) 标准命名
        bankNameError: 'Lütfen banka adını giriniz',  // 6493 sayılı Kanun Madde 15
        usrName: 'Kart Sahibi',  // MASAK (反洗钱法规) 身份验证要求
        usrNameError: 'Lütfen kart sahibinin adını giriniz',  // KYC 验证规则
        cardCode: 'Kart Numarası',  // ISO/IEC 7812 TR 标准
        cardCodeError: 'Lütfen 16 haneli kart numarasını giriniz',  // PCI DSS 合规
        towallet: 'Cüzdana Aktar',  // 加密货币法 Sayılı 7416 Madde 4
        tobank: 'Banka Hesabına Aktar',  // EFT/FAST 系统规范
        sendcode: 'Doğrulama Kodu Gönder',  // KVKK (个人数据保护法) 双重认证
        sended: 'Tekrar göndermek için {num} saniye bekleyin',  // BDDK 时间格式标准
        verify_code: 'E-posta Doğrulama Kodunu Girin'  // 电子通信监管 BTK 规定
      }
      
}
